import {
  Box,
  Container,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import SurveyTabForm from "./SurveyTabForm";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setUpdateSurveyTabAction,
  updateSurveyTabAction,
} from "../../../../store/reducers/leadSurveySlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { calculateRoomVolume } from "./surveyUtils";
import { EditOutlined } from "@mui/icons-material";
import CustomButton from "../../../../components/common/button/CustomButton";
import ManageNewRoom from "./ManageNewRoom";

const SurveyTab: FC<any> = ({
  disabledAction = false,
  subTabvalue = "0",
  setSubTabValue = () => {},
  contentRef,
  setSurveyFirstTabForm,
  isValueChanged,
  setIsValueChanged,
  localSurveyRoomList,
  setLocalSurveyRoomList,
  setSurveyMaterialsPayload = () => {},
  isMaterialsChanged,
  setIsMaterialsChanged = () => {},
}) => {
  // const [value, setValue] = useState(0);
  const [tempValue, setTempValue] = useState(subTabvalue);
  const [surveyForm, setSurveyForm]: any = useState(null);
  const [error, setError] = useState(null);
  const [load, setLoad] = useState(false);
  const { surveyRoomList, isSurveyTabSuccess, surveyedItems } = useSelector(
    (state: any) => state.leadSurvey,
  );
  // edit label
  const [editingTab, setEditingTab] = useState<number | null>(null);
  const [roomName, setRoomName] = useState("");
  const [openRoomModal, setOpenRoomModal] = useState(false);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const dispatch = useDispatch();
  const surveyTabFormRef = useRef<{ submitMaterialsHandler?: () => boolean } | null>(null);

  useEffect(() => {
    if (surveyForm) {
      setSurveyFirstTabForm(surveyForm);
    }
  }, [setSurveyFirstTabForm, surveyForm]);

  useEffect(() => {
    setTempValue(subTabvalue);
    setLoad(false);
    setTimeout(() => {
      setLoad(true);
    }, 1000);
    // Scroll to the top of the content container
    if (contentRef.current) {
      contentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [contentRef, subTabvalue]);

  useEffect(() => {
    if (isSurveyTabSuccess) {
      setSubTabValue(tempValue);
      dispatch(setUpdateSurveyTabAction(false));
    }
  }, [dispatch, isSurveyTabSuccess, setSubTabValue, tempValue]);

  const tabValidator = (formData: any) => {
    let isError = false;
    let localError: any = {};
    const hviInvalidRows: number[] = [];

    if (formData && formData?.length) {
      formData?.forEach((item: any, index: any) => {
        const rowError: any =
          localError?.[index] && typeof localError[index] === "object"
            ? { ...localError[index] }
            : {};

        if (
          item?.quantity === "" ||
          item?.quantity === null ||
          item?.item === "" ||
          item?.item === null ||
          item?.ft3 === "" ||
          item?.ft3 === null
        ) {
        } else {
          if (item?.quantity || !item?.item) {
            if (
              !(
                item?.item &&
                item?.ft3 !== "" &&
                item?.ft3 !== null &&
                item?.quantity
              )
            ) {
              console.log(
                "formData-",
                !(!item?.item && !item?.ft3 && !item?.quantity),
              );
              isError = true;
              rowError.row = true;
            }
          }
        }

        // HVI value must be >= 1000 when HVI is checked.
        const hasHviValue =
          item?.hviValue !== "" && item?.hviValue !== null && item?.hviValue !== undefined && item?.hviValue !== 0;
        if (
          item?.isHVI &&
          hasHviValue &&
          Number(item?.hviValue) < 1000
        ) {
          isError = true;
          rowError.hviValue = true;
          hviInvalidRows.push(index + 1);
        }

        if (Object.keys(rowError).length) {
          localError[index] = rowError;
        }
      });
    } else {
      isError = true;
    }

    if (hviInvalidRows.length > 0) {
      dispatch(
        setNotificationAction({
          message: [
            `HVI value must be at least 1000. Please check row(s): ${hviInvalidRows.join(", ")}.`,
          ],
          severity: "error",
        }),
      );
    }

    return { isError, localError };
  };

  const [localIsMaterialsChanged, setLocalIsMaterialsChanged] = useState(false);

  useEffect(() => {
    setIsMaterialsChanged?.(localIsMaterialsChanged);
  }, [localIsMaterialsChanged, setIsMaterialsChanged]);

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    const saveMaterialsBeforeSwitch = () => {
      if (!localIsMaterialsChanged) {
        return true;
      }

      return surveyTabFormRef.current?.submitMaterialsHandler?.() !== false;
    };

    if (isValueChanged) {
      const { isError, localError }: any = tabValidator(surveyForm);
      setError(localError);

      if (!isError) {
        const surveyPayload = surveyForm?.filter((item: any) => item?.item);
        dispatch(
          updateSurveyTabAction({
            tab: "tab1",
            surveyId: leadDetails?.lead?.survey_id,
            data: {
              name: localSurveyRoomList?.[subTabvalue]?.room,
              roomName: localSurveyRoomList?.[subTabvalue]?.roomName,
              isNew: false,
              items: surveyPayload,
            },
          }),
        );

        if (!saveMaterialsBeforeSwitch()) {
          return;
        }

        setTempValue(newValue);
        setIsValueChanged(false);
      }
    } else {
      if (!saveMaterialsBeforeSwitch()) {
        return;
      }

      setSubTabValue(newValue);
    }
  };

  const completedTab = (room: any) => {
    const filtered = surveyedItems?.list.find((ele: any) => ele?.name === room);
    if (filtered) {
      return "completed";
    } else {
      return "";
    }
  };
  // edit label functionality
  const handleEditClick = (idx: number, tab: any) => {
    setEditingTab(idx);

    const name =
      localSurveyRoomList?.[idx]?.roomName ||
      tab?.roomName ||
      tab?.name ||
      surveyRoomList?.[idx]?.room;

    setRoomName(name);
  };


  return (
    <>
      <Grid container spacing={1} sx={{ marginTop: "5px" }}>
        <Grid
          item
          xs={2}
          sm={2}
          className="surveyTabContainer"
          sx={{ background: "#E5F4F1", padding: "12px", borderRadius: "5px" }}
        >
          <Container fixed sx={{ bgcolor: "#fff", padding: " 0px!important" }}>
             {/* ADD ROOM BUTTON */}
         {!disabledAction && <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <CustomButton variant="outlined" title={'Add Room'} onClick={()=> setOpenRoomModal(true)}/>
          </Box>}
          
            <Tabs
              value={subTabvalue}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
              variant="standard"
              orientation="vertical"
              sx={{
                background: "#E5F4F1",
                fontSize: "14px",
                fontWeight: 600,
                marginBottom: "16px",
                padding: 0,
              }}
            >
              {localSurveyRoomList &&
                localSurveyRoomList.map((tab: any, idx: any) => ({ tab, idx }))
                  .filter(({ tab }: any) => tab?.room !== "Materials")
                  .map(({ tab, idx }: any) => {
                  const roomData = surveyedItems?.list?.find(
                    (ele: any) => ele?.name === tab?.room,
                  );
                  const displayRoomName =
                    localSurveyRoomList?.[idx]?.roomName ||
                    roomData?.roomName ||
                    roomData?.name ||
                    tab?.room;
                  const roomVolume = calculateRoomVolume(roomData?.items || []);
                  return (
                    <Tab
                      value={idx}
                      label={
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* LEFT SIDE */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            {editingTab === idx ? (
                              <TextField
                                size="small"
                                value={roomName}
                                autoFocus
                                onChange={(e) => {
                                  const newName = e.target.value;
                                  setRoomName(newName);

                                  const updatedRooms = [...localSurveyRoomList];
                                  updatedRooms[idx] = {
                                    ...updatedRooms[idx],
                                    roomName: newName,
                                    isNew:true,
                                  };
                                  setLocalSurveyRoomList(updatedRooms); // live update
                                  setIsValueChanged(true);
                                }}
                                onBlur={() => {
                                  setEditingTab(null); //
                                }}
                              />
                            ) : (
                              <>
                               {(subTabvalue === idx && tab?.room !=="Materials" && !disabledAction) && <EditOutlined
                                  sx={{
                                    fontSize: 14,
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditClick(idx, roomData);
                                  }}
                                />}

                                <Typography sx={{ fontSize: "14px" }}>
                                  {displayRoomName}
                                </Typography>
                              </>
                            )}
                          </Box>

                          {/* RIGHT SIDE */}
                          <Typography
                            sx={{
                              color: "#056c16",
                              fontWeight: 600,
                              fontSize: "12px",
                              textTransform: "lowercase",
                            }}
                          >
                            ({roomVolume} m³)
                          </Typography>
                        </Box>
                      }
                      className={completedTab(tab?.room)}
                    />
                  );
                })}
            </Tabs>
          </Container>
        </Grid>
        <Grid item xs={10} sm={10} sx={{ padding: "0px 10px !important" }}>
          {load ? (
            <>
            <SurveyTabForm
              ref={surveyTabFormRef}
              data={localSurveyRoomList ? localSurveyRoomList[subTabvalue] : {}}
              elementId={subTabvalue}
              surveyForm={surveyForm}
              setSurveyForm={setSurveyForm}
              error={error}
              setError={setError}
              tabValidator={tabValidator}
              setIsValueChanged={setIsValueChanged}
              disabledAction={disabledAction}
              isMaterialsChanged={localIsMaterialsChanged}
              setIsMaterialsChanged={setLocalIsMaterialsChanged}
              setSurveyMaterialsPayload={setSurveyMaterialsPayload}
            />
            </>
          ) : (
            "Loading..."
          )}
        </Grid>
      </Grid>
      {openRoomModal &&
      (
        <ManageNewRoom 
          open={openRoomModal}
          title="Add Room"
          onHide={()=> setOpenRoomModal(false)}
          surveyId={leadDetails?.lead?.survey_id}
        />
      )
      }
    </>
  );
};

export default SurveyTab;
